import { useState, useEffect } from 'react'
import { useTuningStore } from '../store/tuningStore'
import { NOTE_NAMES } from '../utils/noteUtils'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { TunerExportModal } from './TunerExportModal'
import { exportTunerFormat } from '../store/tuningStore'
import { exportTunerImage } from '../utils/tunerImage'
import type { TunerNote } from '../store/tuningStore'

export const TonicSection = () => {
  const { referencePitch, tonicNote, tonicFrequency, setTonicNote, setTonicFrequency, noteOffsets, currentPreset, extraNotes } = useTuningStore()
  const [tonicFreqInput, setTonicFreqInput] = useState(tonicFrequency.toFixed(2))
  const [showTunerModal, setShowTunerModal] = useState(false)

  const handleExportTuner = () => {
    setShowTunerModal(true)
  }

  const handleExportSelected = (selectedNotes: TunerNote[]) => {
    const tunerData = exportTunerFormat(noteOffsets, tonicNote, tonicFrequency, referencePitch, currentPreset || undefined, extraNotes)
    const modifiedData = {
      ...tunerData,
      notes: selectedNotes
    }
    exportTunerImage(modifiedData)
  }

  useEffect(() => {
    setTonicFreqInput(tonicFrequency.toFixed(2))
  }, [tonicFrequency])

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <Label className="text-sm whitespace-nowrap">Tonique:</Label>
        <Select
          value={tonicNote.toString()}
          onValueChange={(value) => setTonicNote(parseInt(value))}
        >
          <SelectTrigger className="w-[100px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {NOTE_NAMES.map((note, index) => (
              <SelectItem key={index} value={index.toString()}>
                {note}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <Label className="text-sm whitespace-nowrap">Fréquence:</Label>
        <div className="flex items-center gap-1">
          <Input
            type="text"
            value={tonicFreqInput}
            onChange={(e) => {
              const value = e.target.value
              setTonicFreqInput(value)
            }}
            onBlur={() => {
              const numValue = parseFloat(tonicFreqInput)
              if (isNaN(numValue) || numValue <= 0 || numValue > 2000) {
                setTonicFreqInput(tonicFrequency.toFixed(2))
              } else {
                setTonicFrequency(numValue)
                setTonicFreqInput(numValue.toFixed(2))
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.currentTarget.blur()
              }
            }}
            className="w-20"
          />
          <span className="text-sm text-muted-foreground">Hz</span>
        </div>
      </div>

      <Button
        onClick={handleExportTuner}
        variant="outline"
        size="sm"
      >
        📊 Tuner
      </Button>

      {showTunerModal && (
        <TunerExportModal
          tunerData={exportTunerFormat(noteOffsets, tonicNote, tonicFrequency, referencePitch, currentPreset || undefined, extraNotes)}
          onExport={handleExportSelected}
          onClose={() => setShowTunerModal(false)}
        />
      )}
    </div>
  )
}
